"use strict";

// ============================================================
// OPEN QUESTION: Replace these placeholder emails before deploy
// ============================================================
const ASANA_TASK_ASSIGNEE_EMAIL = "jay@restaurantware.com";
const ASANA_TASK_FOLLOWER_EMAIL = "josh@restaurantware.com";

const DEFAULTS = {
  ENDPOINT: "https://api.rwdomain.com/api/v1/public/asana/task/create",
  FORM_ID: "recommend-product-form",
  HIDDEN_META_ID: "recommend-product-hash",
  SUBMIT_BUTTON_SELECTOR: ".company_custom_button",
  EMAIL_INPUT_ID: "RecNewProd-Email",
  MODAL_ID: "recommend-product-modal",
};

function isValidEmail(value) {
  const email = (value || "").trim();
  return /^[^\s@]+@[^\s@]+\.[^\s@]+$/.test(email);
}

function setFieldError(input, message) {
  const field = input.closest(".field");
  if (!field) return;
  field.classList.add("is-invalid");
  let errorEl = field.querySelector(".field-error");
  if (!errorEl) {
    errorEl = document.createElement("div");
    errorEl.className = "field-error";
    field.appendChild(errorEl);
  }
  errorEl.textContent = message;
}

function clearFieldError(input) {
  const field = input.closest(".field");
  if (!field) return;
  field.classList.remove("is-invalid");
  const errorEl = field.querySelector(".field-error");
  if (errorEl) errorEl.remove();
}

function isFieldValueEmpty(input) {
  if (input.tagName === "SELECT") {
    return !input.value || input.value.trim() === "";
  }
  return (input.value || "").trim() === "";
}

function validateRequiredFields(form) {
  const candidates = form.querySelectorAll(
    "input[required], select[required], textarea[required]",
  );
  let firstInvalid = null;

  candidates.forEach((input) => {
    if (input.type === "radio" || input.type === "checkbox") return;
    if (input.disabled) return;
    if (input.closest("[hidden]")) return;
    if (input.id === DEFAULTS.EMAIL_INPUT_ID) return;

    if (isFieldValueEmpty(input) || !input.checkValidity()) {
      setFieldError(input, "This field is required");
      if (!firstInvalid) firstInvalid = input;
    } else {
      clearFieldError(input);
    }
  });

  const emailInput = document.getElementById(DEFAULTS.EMAIL_INPUT_ID) ||
    form.querySelector(`#${DEFAULTS.EMAIL_INPUT_ID}`);
  if (emailInput && isFieldValueEmpty(emailInput)) {
    setFieldError(emailInput, "This field is required");
    if (!firstInvalid) firstInvalid = emailInput;
  }

  if (firstInvalid) {
    if (typeof firstInvalid.focus === "function") firstInvalid.focus({ preventScroll: true });
    if (typeof firstInvalid.scrollIntoView === "function") {
      firstInvalid.scrollIntoView({ behavior: "smooth", block: "center" });
    }
  }

  return !firstInvalid;
}

function validateEmailField(form) {
  const input = document.getElementById(DEFAULTS.EMAIL_INPUT_ID) ||
    form.querySelector(`#${DEFAULTS.EMAIL_INPUT_ID}`);
  if (!input) return true;

  if (!isValidEmail(input.value)) {
    setFieldError(input, "Please enter a valid email address");
    if (typeof input.focus === "function") input.focus({ preventScroll: true });
    if (typeof input.scrollIntoView === "function") {
      input.scrollIntoView({ behavior: "smooth", block: "center" });
    }
    return false;
  }

  clearFieldError(input);
  return true;
}

function setRadioGroupError(form, name, message) {
  const firstRadio = form.querySelector(`input[name="${name}"]`);
  if (!firstRadio) return;
  const segment = firstRadio.closest(".recommend-product-question") || firstRadio.closest(".register-segment");
  if (!segment) return;

  let errorEl = segment.querySelector(".field-error");
  if (!message) {
    if (errorEl) errorEl.remove();
    return;
  }

  if (!errorEl) {
    errorEl = document.createElement("div");
    errorEl.className = "field-error";
    segment.appendChild(errorEl);
  }
  errorEl.textContent = message;
}

function validateRadioGroups(form) {
  const groups = ["openToMeeting", "devCouncil"];
  let firstInvalidGroup = null;

  groups.forEach((name) => {
    const checked = form.querySelector(`input[name="${name}"]:checked`);
    if (checked) {
      setRadioGroupError(form, name, "");
    } else {
      setRadioGroupError(form, name, "Please select an option");
      if (!firstInvalidGroup) firstInvalidGroup = name;
    }
  });

  if (firstInvalidGroup) {
    const target = form.querySelector(`input[name="${firstInvalidGroup}"]`);
    if (target && typeof target.focus === "function") target.focus({ preventScroll: true });
    if (target && typeof target.scrollIntoView === "function") {
      target.scrollIntoView({ behavior: "smooth", block: "center" });
    }
  }

  return !firstInvalidGroup;
}

function showLoadingState(submitBtn, spinnerElement) {
  if (spinnerElement) spinnerElement.style.display = "block";
  if (submitBtn) submitBtn.disabled = true;
}

function hideLoadingState(submitBtn, spinnerElement) {
  if (spinnerElement) spinnerElement.style.display = "none";
  if (submitBtn) submitBtn.disabled = false;
}

function openModal(type, title, message) {
  const modal = document.getElementById(DEFAULTS.MODAL_ID);
  if (!modal) return;

  const dialog = modal.querySelector(".recommend-product-modal");
  const titleEl = modal.querySelector(".recommend-product-modal-title");
  const textEl = modal.querySelector(".recommend-product-modal-text");

  if (dialog) {
    dialog.classList.toggle("is-success", type === "success");
    dialog.classList.toggle("is-error", type === "error");
  }
  if (titleEl) titleEl.textContent = title;
  if (textEl) textEl.textContent = message;

  modal.hidden = false;
  document.body.style.overflow = "hidden";
  const okButton = modal.querySelector(".recommend-product-modal-ok");
  if (okButton && typeof okButton.focus === "function") okButton.focus();
}

function openSuccessModal() {
  openModal("success", "Thank you!", "Your recommendation has been submitted.");
}

function openErrorModal(message) {
  openModal("error", "Something went wrong", message);
}

function closeModal() {
  const modal = document.getElementById(DEFAULTS.MODAL_ID);
  if (!modal) return;
  modal.hidden = true;
  document.body.style.overflow = "";
}

function initializeModal() {
  const modal = document.getElementById(DEFAULTS.MODAL_ID);
  if (!modal) return;

  const closeButton = modal.querySelector(".recommend-product-modal-close");
  const okButton = modal.querySelector(".recommend-product-modal-ok");

  if (closeButton) closeButton.addEventListener("click", closeModal);
  if (okButton) okButton.addEventListener("click", closeModal);

  modal.addEventListener("click", (event) => {
    if (event.target === modal) closeModal();
  });

  document.addEventListener("keydown", (event) => {
    if (event.key === "Escape" && !modal.hidden) closeModal();
  });
}

function getFormValue(form, id) {
  const el = document.getElementById(id) || form.querySelector(`#${id}`);
  return el?.value?.trim() ?? "";
}

function getCheckedValue(form, name) {
  return form.querySelector(`input[name="${name}"]:checked`)?.value ?? "";
}

function buildAsanaTaskTitle(form) {
  const company = getFormValue(form, "RecNewProd-Company");
  const date = new Date().toISOString().slice(0, 10);
  return "Recommend a New Product - " + company + " - " + date;
}

function buildAsanaTaskDescription(form) {
  const lines = [];
  lines.push("Product Recommendation Request");
  lines.push("==============================");
  lines.push("");
  lines.push("Submitted: " + new Date().toISOString().replace("T", " ").slice(0, 16));
  lines.push("");
  lines.push("Product Details:");
  lines.push("  Product Type: " + getFormValue(form, "RecNewProd-ProductType"));
  lines.push("  Color: " + getFormValue(form, "RecNewProd-Color"));
  lines.push("  Size: " + getFormValue(form, "RecNewProd-Size"));
  lines.push("");
  lines.push("Problem & Current Solution:");
  lines.push("  Problem Being Solved: " + getFormValue(form, "RecNewProd-ProblemSolving"));
  lines.push("  Currently Using: " + getFormValue(form, "RecNewProd-UsingToday"));
  lines.push("");
  lines.push("Engagement:");
  lines.push("  Open to Meeting with Product Dev Team: " + (getCheckedValue(form, "openToMeeting") === "true" ? "Yes" : "No"));
  lines.push("  Interested in Product Development Council: " + (getCheckedValue(form, "devCouncil") === "true" ? "Yes" : "No"));
  lines.push("");
  lines.push("Contact Information:");
  lines.push("  Name: " + getFormValue(form, "RecNewProd-Name"));
  lines.push("  Email: " + getFormValue(form, "RecNewProd-Email"));
  lines.push("  Job Title: " + getFormValue(form, "RecNewProd-JobTitle"));
  lines.push("  Company: " + getFormValue(form, "RecNewProd-Company"));
  return lines.join("\n");
}

function collectPayload(form) {
  return {
    title: buildAsanaTaskTitle(form),
    description: buildAsanaTaskDescription(form),
    assignee: ASANA_TASK_ASSIGNEE_EMAIL,
    followers: [ASANA_TASK_FOLLOWER_EMAIL],
  };
}

async function submitFormToAPI(payload) {
  const meta = document.getElementById(DEFAULTS.HIDDEN_META_ID);
  const submitBtn = document.querySelector(DEFAULTS.SUBMIT_BUTTON_SELECTOR);
  const spinnerElement = document.querySelector(".customer_login_spinner");
  const pageId = meta?.dataset.pageId;
  const hashKey = meta?.dataset.hashKey;
  const endpoint = meta?.dataset.endpoint || DEFAULTS.ENDPOINT;

  if (!pageId || !hashKey) {
    openErrorModal("Missing request token. Please refresh and try again.");
    return;
  }

  const endpointWithKey =
    `${endpoint}?pageId=${encodeURIComponent(pageId)}&key=${encodeURIComponent(hashKey)}`;

  showLoadingState(submitBtn, spinnerElement);

  try {
    const response = await fetch(endpointWithKey, {
      method: "POST",
      headers: { "Content-Type": "application/json" },
      body: JSON.stringify(payload),
    });

    let data = {};
    try {
      data = await response.json();
    } catch (error) {
      data = {};
    }

    if (response.ok && data.code === 0) {
      hideLoadingState(submitBtn, spinnerElement);
      openSuccessModal();
      if (submitBtn) {
        const labelSpan = submitBtn.querySelector("span:nth-child(2)");
        if (labelSpan) labelSpan.textContent = "Recommendation Submitted";
        submitBtn.disabled = true;
      }
      return;
    }

    hideLoadingState(submitBtn, spinnerElement);
    openErrorModal("Something went wrong. Please try again or contact support.");
  } catch (error) {
    hideLoadingState(submitBtn, spinnerElement);
    openErrorModal("Something went wrong. Please try again or contact support.");
  }
}

function initializeFormHandler() {
  const form = document.getElementById(DEFAULTS.FORM_ID);
  if (!form) return;

  initializeModal();

  form.addEventListener("input", (event) => {
    const target = event.target;
    if (!target || !target.closest || !target.closest(".field")) return;
    if (target.type === "radio" || target.type === "checkbox") return;
    if (!isFieldValueEmpty(target) && target.checkValidity()) {
      clearFieldError(target);
    }
  });

  form.addEventListener("change", (event) => {
    const target = event.target;
    if (!target || target.type !== "radio") return;
    if (target.name === "openToMeeting" || target.name === "devCouncil") {
      setRadioGroupError(form, target.name, "");
    }
  });

  form.addEventListener("submit", (event) => {
    event.preventDefault();

    if (!validateRequiredFields(form)) {
      return;
    }

    if (!validateEmailField(form)) {
      return;
    }

    if (!validateRadioGroups(form)) {
      return;
    }

    const payload = collectPayload(form);
    submitFormToAPI(payload);
  });
}

document.addEventListener("DOMContentLoaded", initializeFormHandler);
